export default __webpack_public_path__ + "static/media/preparing.9fcdf1c1.svg";